export default {
  subscribe: {
    en: 'Subscribe for only $11.21',
  },
  hint: {
    en: '*first month new subscriptions only',
  },
}
